module.exports = __webpack_public_path__ + "res/img_more.30954b8506f21312a0d17bbd54c2f844.png";